import { makeStyles, createStyles } from '@material-ui/core';
import Button from 'app/components/Button';
import React from 'react';
import colors from '../../../../constants/colors';

type StickyCTAProp = {
  ctaText?: string;
  ctaOnClick?: Function;
};

const StickyCTA = ({ ctaText, ctaOnClick }: StickyCTAProp) => {
  const useStyles = makeStyles(() =>
    createStyles({
      root: {
        boxSizing: 'border-box',
        position: 'fixed',
        bottom: 0,
        left: 0,
        zIndex: 99,
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '8px 24px',
        borderTop: '0.5px solid #aaa',
        background: colors.darker_blue,
      },
      info: {
        fontSize: 14,
        fontWeight: 400,
        color: '#aaa',
        margin: 0,
        width: 100,
      },
    }),
  );
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <p className={classes.info}>We’ll cover the gas fees</p>
      {/*
        @ts-ignore */}
      <Button displayType="primary" onClick={ctaOnClick}>
        {/*
          @ts-ignore */}
        {ctaText}
      </Button>
    </div>
  );
};

export default StickyCTA;
